import React, { useState, useEffect } from 'react';

import styles from './ImageItem.module.css';

const ImageItem = ({ image, isGallery, isEditingRow }) => {
  const [weight, setWeight] = useState(null);

  useEffect(() => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', image, true);
    xhr.responseType = 'blob';
    xhr.onload = function() {
      let w = xhr.response.size;
      w = w ? (w / 1000).toFixed(1) : 0;
      w = w > 1000 ? `${(w / 1000).toFixed(1)} MB` : `${w} KB`;
      setWeight(w);
    };
    xhr.send();
  }, []);

  return (
    <li>
      {isEditingRow && isGallery && (
        <button
          type="button"
          id="orderButton"
          className={`naked-button ${styles.button} ${styles.orderButton}`}
        >
          <i className="far fa-ellipsis-v" />
          <i className="far fa-ellipsis-v" />
        </button>
      )}
      <a
        className={styles.link}
        href={image}
        target="_blank"
        rel="noopener noreferrer"
      >
        {image}
      </a>
      {weight && <span className={styles.weight}>{`(${weight})`}</span>}
      <div className={styles.buttons}>
        <a
          className={`naked-button ${styles.button}`}
          href={image}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="far fa-external-link-square-alt" id="view-image" />
        </a>
      </div>
    </li>
  );
};

export default ImageItem;
